import { Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { ToastAction, ToastData, ToastType } from './toast.model';

@Component({
  selector: 'toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  get iconName(): string {
    return this.getIconByType(this.data.type);
  }

  get typeClass(): string {
    return `toast-${this.data.type}`;
  }

  constructor(
    private snackBarRef: MatSnackBarRef<ToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: ToastData,
  ) {}

  async onActionClick(action: ToastAction): Promise<void> {
    try {
      if (action.callback) {
        await action.callback();
      }
    } finally {
      if (action.closeAfterClick !== false) {
        this.snackBarRef.dismiss();
      }
    }
  }

  onClose(): void {
    this.snackBarRef.dismiss();
  }

  trackByLabel(_: number, action: ToastAction): string {
    return action.label;
  }

  private getIconByType(type: ToastType): string {
    switch (type) {
      case 'success':
        return 'check_circle';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      case 'error':
        return 'error';
      default:
        return 'notifications';
    }
  }
}
